// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import './App.css';
// import Speeches from './website/Speeches/Speeches';
// import Home from './website/Home/Home';
// import Videos from './website/Videos/Videospage';
// import Audio from './website/Audio/Audiopage';
// import Postpage from './website/Posts/PostPage';
// import Products from './website/Products/Productspage';
// import Searchpage from './website/Search/SearchPage';
// import SearchCategoryPage from './website/Search/SearchByCateg';
// import LanguageSelector from './Language/LanguageLandingpage';
// import LanguageGuard from './Language/LanguageGuards';
// import NotFound from './Language/Notfound';
// import { HelmetProvider } from 'react-helmet-async';
// import FloatingLanguageSwitcher from './Components/Langauges/FloatingLanguageSwitcher';
// import { useEffect } from 'react';
// import LoadingOverlay from './Components/Loading/LoadingOverlay';
// document.documentElement.setAttribute('dir', 'rtl');

// function App() {

//     useEffect(() => {
//     const lanuagePicked = localStorage.getItem('siteLanguage');
    
//     if (!lanuagePicked) {
//       localStorage.setItem('siteLanguage', 'fa');
//       document.documentElement.lang = 'fa';
//       document.documentElement.dir = 'rtl';
//     }
//   }, []);
//   return (<>


//   <HelmetProvider>
//      <Router>
//       <Routes>

//         {/* <Route path='/' element={<LanguageSelector />} /> */}
        

//         <Route path="/*" element={
//           // <LanguageGuard>
//             <Routes>
//               {/* Home Routes */}
//               <Route path='/' element={<Home />} />
//               <Route path='/home' element={<Home />} />
//               <Route path='/home/searchAll/:search' element={<Searchpage />} />

//               {/* Videos Routes */}
//               <Route path='/videos' element={<Videos />} />
//               <Route path='/videos/:year' element={<Videos />} />
//               <Route path='/videos/:year/:slug/:id' element={<Postpage />} />
//               <Route path='/videos/searchVideos/:search' element={<Searchpage />} />
//               <Route path='/:category/SearchByCategoryResult/:search' element={<SearchCategoryPage />} />

//               {/* Audio Routes */}
//               <Route path='/audios' element={<Audio />} />
//               <Route path='/audios/:year' element={<Audio />} />
//               <Route path='/audios/:year/:slug/:id' element={<Postpage />} />
//               <Route path='/audios/searchAudios/:search' element={<Searchpage />} />
//               <Route path='/:category/SearchByCategoryResult/:search' element={<SearchCategoryPage />} />

//               {/* Productions Routes */}
//               <Route path='/productions' element={<Products />} />
//               <Route path='/productions/:year' element={<Products />} />
//               <Route path='/productions/:year/:slug/:id' element={<Postpage />} />
//               <Route path='/productions/searchProductions/:search' element={<Searchpage />} />
//               <Route path='/:category/SearchByCategoryResult/:search' element={<SearchCategoryPage />} />
             
//               {/* Speeches Routes */}
//               <Route path='/speeches' element={<Speeches />} />
//               <Route path='/speeches/:year' element={<Speeches />} />
//               <Route path='/speeches/:year/:slug/:id' element={<Postpage />} />
//               <Route path='/speeches/searchSpeeches/:search' element={<Searchpage />} />
//               <Route path='/:category/SearchByCategoryResult/:search' element={<SearchCategoryPage />} />

//               <Route path='/Landing' element={<LoadingOverlay />} />
              
//               {/* Catch-all route for any random URLs */}
//               <Route path="*" element={<NotFound />} />
//             </Routes>
//           // </LanguageGuard>
//         } />
//       </Routes>

//       {/* Floating Language Switcher - Always visible */}
//               <FloatingLanguageSwitcher/>
//     </Router>
//   </HelmetProvider>


//     </>);
// }

// export default App;








import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import './index.css';

import Speeches from './website/Speeches/Speeches';
import Home from './website/Home/Home';
import Videos from './website/Videos/Videospage';
import Audio from './website/Audio/Audiopage';
import Postpage from './website/Posts/PostPage';
import Products from './website/Products/Productspage';
import Searchpage from './website/Search/SearchPage';
import SearchCategoryPage from './website/Search/SearchByCateg';
import NotFound from './Language/Notfound';
import FloatingLanguageSwitcher from './Components/Langauges/FloatingLanguageSwitcher';
import LoadingOverlay from './Components/Loading/LoadingOverlay';
import People from './Components/People/People';
import Stories from './website/Stories/StoriesPage';
import StoryPage from './website/Posts/PostStory';


document.documentElement.setAttribute('dir', 'rtl');

function App() {
  return (
    <HelmetProvider>
      <Router>
        <MainApp />
      </Router>
    </HelmetProvider>
  );
}

function MainApp() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const languagePicked = localStorage.getItem('siteLanguage');
    
    if (!languagePicked) {
      localStorage.setItem('siteLanguage', 'fa');
      document.documentElement.lang = 'fa';
      document.documentElement.dir = 'rtl';
    }
  }, []);

  // useEffect(() => {
  //   setIsLoading(true);
  //   const timer = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, [location.pathname]);

  return (
    <>
      <Routes>

        {/* Home Routes */}
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/home/searchAll/:search' element={<Searchpage />} />

        {/* Videos Routes */}
        <Route path='/videos' element={<Videos />} />
        <Route path='/videos/:year' element={<Videos />} />
        <Route path='/videos/:year/:slug/:id' element={<Postpage />} />
        <Route path='/videos/searchVideos/:search' element={<Searchpage />} />


        {/* Audio Routes */}
        <Route path='/audios' element={<Audio />} />
        <Route path='/audios/:year' element={<Audio />} />
        <Route path='/audios/:year/:slug/:id' element={<Postpage />} />
        <Route path='/audios/searchAudios/:search' element={<Searchpage />} />


        {/* Productions Routes */}
        <Route path='/productions' element={<Products />} />
        <Route path='/productions/:year' element={<Products />} />
        <Route path='/productions/:year/:slug/:id' element={<Postpage />} />
        <Route path='/productions/searchProductions/:search' element={<Searchpage />} />
       

       {/* Speeches Routes */}
        <Route path='/speeches' element={<Speeches />} />
        <Route path='/speeches/:year' element={<Speeches />} />
        <Route path='/speeches/:year/:slug/:id' element={<Postpage />} />
        <Route path='/speeches/searchSpeeches/:search' element={<Searchpage />} />


        {/* Catch-all route for any random URLs */}
        <Route path='/:category/SearchByCategoryResult/:search' element={<SearchCategoryPage />} />

        {/* test */}
        {/* <Route path='/people' element={<People />} /> */}

        {/* Stories Routes */}
        <Route path='/stories' element={<Stories />} />
        {/* <Route path='/speeches/searchSpeeches/:search' element={<Searchpage />} /> */}
        <Route path='/stories/:slug/:id' element={<StoryPage />} />


        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* {isLoading && <LoadingOverlay />} */}

      {/* Floating Language Switcher - Always visible */}
      <FloatingLanguageSwitcher setIsLoading={setIsLoading} />
    </>
  );
}

export default App;
